import AccordionItem from "../../components/AccordionItem";
import DocLists from "./DocLists";

const DocCollapse = ({
  docGroups = [],
  keyTitle = "docgrouptitle",
  keyDocs = "docitem",
}) => {
  return (
    <div className="mx-auto p-4" style={{ width: "100%" }}>
      {docGroups.map((group, gIndex) => {
        return (
          <AccordionItem key={gIndex} title={group[keyTitle]}>
            <DocLists
              docs={group[keyDocs]}
              keyLabel="doctitle"
              onDocClick={(ev) => window.open(ev.doclink, "_blank")}
            />
          </AccordionItem>
        );
      })}
    </div>
  );
};

export default DocCollapse;
